import React, { Ref, FC, useState, useCallback, useRef, RefObject } from 'react';
import cn from 'classnames';
require("./Review.css");
var styles = {
  "Root": "Review-module-Root_1nO",
  "Rating": "Review-module-Rating_2oF",
  "Overlay": "Review-module-Overlay_3XB",
  "Demo": "Review-module-Demo_3AO",
  "Text": "Review-module-Text_2qR",
  "Skip": "Review-module-Skip_3Z6",
  "Name": "Review-module-Name_3Dj",
  "Data": "Review-module-Data_3Cw",
  "Counter": "Review-module-Counter_3bn",
  "Control": "Review-module-Control_2qg"
};
import { Rating } from '../Rating';
import { AmountCounter } from '../AmountCounter';
import { Typography } from '../Typography';
import { Link } from '../Link';
import { AmountCounterPressedButtonVariants } from '../AmountCounter';
import { LinkTags } from '../Link';
import { useIsomorphicLayoutEffect } from '../../hooks/useIsomorphicLayoutEffect';
const DEFAULT_RATING = 0;
export const Review = ({
  className,
  children,
  valueRating = DEFAULT_RATING,
  userName,
  initialValueVote,
  userVoted,
  dataReview,
  innerRef,
  controlRef
}) => {
  const [viewDemo, setViewDemo] = useState(false);
  const refText = useRef();
  useIsomorphicLayoutEffect(() => {
    if (refText.current && typeof window !== 'undefined') {
      const style = window.getComputedStyle(refText.current);
      const heightSingleRow = parseInt(style.lineHeight.replace(/^\D+/g, ''), 10);
      refText.current.clientHeight > heightSingleRow * 3 && setViewDemo(true);
    }
  }, []);
  const handleOpen = useCallback(() => {
    setViewDemo(false);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Root, className),
    ref: innerRef || controlRef
  }, /*#__PURE__*/React.createElement(Rating, {
    className: styles.Rating,
    value: valueRating,
    size: "s",
    filled: false
  }), /*#__PURE__*/React.createElement("div", {
    className: `${styles.Overlay} ${viewDemo ? styles.Demo : ''}`
  }, /*#__PURE__*/React.createElement(Typography, {
    className: styles.Text,
    tag: "p",
    variant: "p1",
    innerRef: refText
  }, children)), viewDemo && /*#__PURE__*/React.createElement(Link, {
    onClick: handleOpen,
    className: styles.Skip,
    tag: LinkTags.button
  }, "\u0427\u0438\u0442\u0430\u0442\u044C \u0434\u0430\u043B\u0435\u0435"), /*#__PURE__*/React.createElement(Typography, {
    className: styles.Name,
    tag: "p",
    variant: "p2"
  }, userName), /*#__PURE__*/React.createElement(Typography, {
    className: styles.Data,
    tag: "p",
    variant: "p2"
  }, dataReview), /*#__PURE__*/React.createElement("div", {
    className: styles.Counter
  }, /*#__PURE__*/React.createElement(Typography, {
    tag: "p",
    variant: "p2"
  }, "\u041E\u0442\u0437\u044B\u0432 \u043F\u043E\u043B\u0435\u0437\u0435\u043D?"), /*#__PURE__*/React.createElement(AmountCounter, {
    className: styles.Control,
    type: "vote",
    mode: "vote",
    size: "s",
    initialValue: initialValueVote,
    pressedButton: userVoted
  })));
};